<template>
  <div class="app-container">
    <el-container>
      <type-tree
        ref="typeTree"
        @on-select="onSelect"
        v-if="loginInfo.UserType == 1"
      ></type-tree>
      <typePlatform-tree
        ref="typePlatformTree"
        @on-select2="onSelect2"
        v-else
      ></typePlatform-tree>

      <el-main class="my-main">
        <list ref="list" is-mall-goods>
          <template slot="toolbar-right">
            <!-- <el-button size="mini" type="primary" @click="shelves">批量上/下架</el-button> -->

            <el-dropdown
              v-if="$permission.canSale()"
              trigger="click"
              style="margin-right: 10px"
              @command="handleCommand"
            >
              <el-button type="primary">
                上/下架<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" class="shelves">
                <el-dropdown-item command="up">批量上架</el-dropdown-item>
                <el-dropdown-item command="down">批量下架</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <!-- <el-dropdown
              v-if="$permission.canNew()"
              trigger="click"
              style="margin-right: 10px"
              @command="handleCommandNew"
            >
              <el-button type="primary">
                新品<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" class="shelves">
                <el-dropdown-item command="New">发布新品</el-dropdown-item>
                <el-dropdown-item command="NewCancel"
                  >取消新品</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown
              v-if="$permission.canHot()"
              trigger="click"
              style="margin-right: 10px"
              @command="handleCommandHot"
            >
              <el-button type="primary">
                热卖<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" class="shelves">
                <el-dropdown-item command="Hot">发布热卖</el-dropdown-item>
                <el-dropdown-item command="HotCancel"
                  >取消热卖</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown
              v-if="$permission.canRecommend()"
              trigger="click"
              style="margin-right: 10px"
              @command="handleCommandRecommend"
            >
              <el-button type="primary">
                爆款<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown" class="shelves">
                <el-dropdown-item command="Recommend"
                  >发布爆款</el-dropdown-item
                >
                <el-dropdown-item command="RecommendCancel"
                  >取消爆款</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown> -->
            <el-button size="mini" type="success" @click="showCategory()" v-if="$permission.canCategory()">切换分类</el-button>
            <el-button
              size="mini"
              type="primary"
              @click="showUpdate()"
              v-if="false"
              >批量修改</el-button
            >
            <!--  <el-button size="mini" type="success" plain @click="onImportup">导入上架信息</el-button>
            <el-button size="mini" type="success" plain @click="onImportupab">导入规格价格信息</el-button> -->

            <el-button
              type="danger"
              @click="delRows"
              v-if="$permission.canDel()"
              >删除</el-button
            >
          </template>

          <template slot="column">
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="100"
            >
              <template slot-scope="{ row }">
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="editById(row.RecordId)"
                  v-if="!$permission.canEdit()"
                ></el-button>
                <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="editById(row.RecordId)"
                  v-if="$permission.canEdit()"
                ></el-button>
               <el-button type="text" icon="el-icon-delete" @click="del(row.RecordId)" v-if="$permission.canDel()"></el-button>
                <!-- <el-button type="text" icon="el-icon-plus" @click="add(row)" title="添加到视频号"></el-button> -->
              </template>
            </el-table-column>
          </template>
        </list>
      </el-main>
    </el-container>
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
    <detail-dialog ref="detailDialog" @close-saved="reload"></detail-dialog>
    <update-dialog ref="updateDialog"></update-dialog>
    <updateType-dialog ref="updateTypeDialog" @close-saved="reload"></updateType-dialog>
    <import-dialogup ref="importDialogup" @upload-success="reload" />
    <import-dialogupab ref="importDialogupab" @upload-success="reload" />
    <import-dialogimg ref="importDialogimg" @upload-success="reload" />
    <edit-dialogstore
      ref="editDialogstore"
      @close-saved="reload"
    ></edit-dialogstore>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/goods/info/list";
import editDialog from "@/components/sale/mallgoods/editDialog";
import detailDialog from "@/components/sale/mallgoods/detailDialog";
import importDialogup from "@/components/sale/mallgoods/importDialogup";
import importDialogupab from "@/components/sale/mallgoods/importDialogupab";
import importDialogimg from "@/components/sale/mallgoods/importDialogimg";
import typeTree from "@/components/goods/info/typeTree";
import typePlatformTree from "@/components/goods/info/typePlatformTree";
import updateDialog from "@/components/sale/mallgoods/updateDialog"; //引入批量修改的界面
import editDialogstore from "@/components/sale/mallgoods/editDialogstore";
import updateTypeDialog from "@/components/sale/mallgoods/updateTypeDialog"; //引入批量修改的界面
export default {
  name: "mallgoods",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    importDialogup,
    importDialogupab,
    importDialogimg,
    typeTree,
    updateDialog,
    editDialogstore,
    typePlatformTree,
    detailDialog,
    updateTypeDialog,
  },
  data() {
    return {
      data: {
        TypeName: "",
        TypeId: 0,
        TypeIdChain: "",
      },
      canCreate: false,
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
    };
  },
  mounted() {
    if (this.loginInfo.UserType == 1) {
      this.$refs.typeTree.getData();
    } else {
      this.$refs.typePlatformTree.getData();
    }
  },
  methods: {
    detailById(id) {
      this.$refs.detailDialog.openDetailsById(id);
    },
    showUpdate() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length <= 1) {
        this.$message.warning("请选择多于一条的数据");
        return;
      } else {
        let ids = rows.map((item) => item.RecordId);
        this.$refs.updateDialog.open().then((that) => {
          that.getData(ids); //that表示打开的那个窗口
        });
      }
    },
    // reload() {
    //   this.$refs.list.getData({ State: 1 });
    // },
    onSelect(data) {
      console.log("on-select", JSON.parse(JSON.stringify(data)));
      if (data.RecordId != -1 && data.children == undefined)
        this.canCreate = true;
      else this.canCreate = false;

      if (this.data.TypeIdChain != data.IdChain) {
        this.data.TypeId = data.RecordId;
        this.data.TypeName = data.TypeName;
        this.data.TypeIdChain = data.IdChain;
        if (data.RecordId > 0)
          this.$refs.list.getData({ TypeIdChain: this.data.TypeIdChain });
        else this.$refs.list.getData({});
      }
    },
    onSelect2(data) {
      console.log("on-select2", JSON.parse(JSON.stringify(data)));
      if (data.RecordId != -1 && data.children == undefined)
        this.canCreate = true;
      else this.canCreate = false;

      if (this.data.TypeIdChain != data.IdChain) {
        this.data.TypePlatformId = data.RecordId;
        this.data.TypePlatformName = data.TypeName;
        this.data.TypePlatformIdChain = data.IdChain;
        this.data.TypePlatformNameChain = data.NameChain;
        if (data.RecordId > 0)
          this.$refs.list.getData({
            TypePlatformIdChain: this.data.TypePlatformIdChain,
          });
        else this.$refs.list.getData({});
      }
    },
    create() {
      this.$refs.editDialog.openCreate(this.data);
    },
    add(row) {
      console.log(row, "row");
      console.log(this.$refs);
      this.$refs.editDialogstore.openEditById(row.RecordId);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => item.RecordId);
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    onImportup() {
      this.$refs.importDialogup.open();
    },
    onImportupab() {
      this.$refs.importDialogupab.open();
    },
    onImportimg() {
      this.$refs.importDialogimg.open();
    },
    handleCommand(value) {
      console.log("handleCommand", value);
      let rows = this.$refs.list.getCheckedRows();
      console.log("rows", JSON.parse(JSON.stringify(rows)));

      if (rows.length == 0) {
        this.$message.warning("请选择要上/下架的数据");
        return;
      }
      // if (value == "up") {
      //   if (rows.some(x => !x.OriginalPrice)) {
      //     this.$message.warning("有部分商品原价还未设置，无法上架");
      //     return;
      //   }
      // }
      var data = {
        RecordIds: rows.map((item) => item.RecordId),
        SaleState: value == "up" ? 1 : 0,
      };
      this.$refs.list.updateSaleState(data);
    },
    handleCommandRecommend(value) {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择发布/取消推荐的数据");
        return;
      }
      var data = {
        RecordIds: rows.map((item) => item.RecordId),
        IfRecommend: value == "Recommend" ? 1 : 0, //推荐就传入1，取消就传入0,IfRecommend就是后端接口定义的实体里面的名称
      };
      this.$refs.list.updateRecommendState(data);
    },
    handleCommandHot(value) {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择发布/取消热卖的数据");
        return;
      }
      var data = {
        RecordIds: rows.map((item) => item.RecordId),
        IfHot: value == "Hot" ? 1 : 0, //热卖就传入1，取消就传入0,IfHot就是后端接口定义的实体里面的名称
      };
      this.$refs.list.updateHotState(data);
    },
    handleCommandNew(value) {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择发布/取消新品的数据");
        return;
      }
      var data = {
        RecordIds: rows.map((item) => item.RecordId),
        IfNew: value == "New" ? 1 : 0, //新品就传入1，取消就传入0,IfNew就是后端接口定义的实体里面的名称
      };
      this.$refs.list.updateNewState(data);
    },
    showCategory(){
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择切换分类的数据");
        return;
      }
       let ids = rows.map((item) => item.RecordId);
        this.$refs.updateTypeDialog.open().then((that) => {
          that.getData(ids); //that表示打开的那个窗口
        });
    }
  },
};
</script>
<style lang="scss">
.my-main {
  padding: 0;
  padding-left: 10px;
}

.shelves {
  width: 112px;

  li {
    line-height: 30px !important;
    font-size: 14px !important;
  }
}
</style>